import axios from "axios";

export const getHelper = (
  url,
  type,
  dispatch,
  refresh = false,
  extra_data = null,
) => {
  dispatch({
    type,
    payload: {
      isFetching: true,
      isRefreshing: refresh,
      error: false,
      result: [],
    },
  });

  return axios
    .get(url)
    .then((res) => {
      let _result = res.data.result;
      if (extra_data) {
        _result = { ..._result, ...extra_data };
      }
      dispatch({
        type: type,
        payload: {
          isFetching: false,
          isRefreshing: false,
          error: false,
          result: _result,
        },
      });
    })
    .catch((err) => {
      let error = "";

      if (err.message) {
        error = err.message;
      } else {
        error = JSON.stringify(err);
      }

      dispatch({
        type: type,
        payload: {
          error,
          isFetching: false,
          isRefreshing: false,
          result: [],
        },
      });
    });
};

export const startFetchHelper = (type, dispatch) => {
  dispatch({
    type,
    payload: {
      isFetching: true,
      isRefreshing: false,
      error: false,
      result: [],
    },
  });
};

// When refreshing data we do not want to clear out 'result' in the state.
// Clearing 'result'...results in the data disappearing while the new data is gathered.
export const startRefreshHelper = (type, dispatch) => {
  dispatch({
    type,
    payload: {
      isFetching: false,
      isRefreshing: true,
      error: false,
    },
  });
};

export const getRefreshHelper = (url, type, dispatch, extra_data = null) => {
  startRefreshHelper(type, dispatch);
  return axios
    .get(url)
    .then((res) => {
      let _result = res.data.result;

      if (extra_data) {
        _result = { ..._result, ...extra_data };
      }
      dispatch({
        type: type,
        payload: {
          isFetching: false,
          isRefreshing: false,
          error: false,
          result: _result,
        },
      });
    })
    .catch((err) => {
      let error = "";

      if (err.message) {
        error = err.message;
      } else {
        error = JSON.stringify(err);
      }

      dispatch({
        type: type,
        payload: {
          error,
          isFetching: false,
          isRefreshing: false,
          result: [],
        },
      });
    });
};
